/**
 * Saisie automatique du code reçu par e-mail dans `ngx-otp-input` (MOKA-360).
 *
 * La bibliothèque impose `autocomplete="off"` et `maxlength="1"` : le clavier iOS / Android ne
 * propose donc jamais le code. On rouvre la première case (`one-time-code`, sans longueur
 * maximale) et, quand le système y dépose les 6 chiffres d'un coup, on les rejoue comme une
 * frappe case par case — chemin que la bibliothèque traite déjà.
 *
 * À appeler une fois le composant rendu ; sans effet si les cases n'existent pas encore.
 */
export function enableOtpAutofill(host: HTMLElement, otpLength = 6): void {
  const form = host.querySelector<HTMLFormElement>('.ngx-otp-input-form');
  const boxes = Array.from(form?.querySelectorAll<HTMLInputElement>('input') ?? []);
  const first = boxes[0];
  if (!first || first.dataset['otpAutofill'] === 'on') return;

  first.dataset['otpAutofill'] = 'on';
  first.setAttribute('autocomplete', 'one-time-code');
  first.removeAttribute('maxlength');

  first.addEventListener('input', (event) => {
    const digits = first.value.replace(/\D/g, '');
    if (first.value.length <= 1) return;

    // Valeur multiple : la bibliothèque l'effacerait. On la redistribue nous-mêmes.
    event.stopImmediatePropagation();
    first.value = '';
    if (digits.length !== otpLength) return;

    boxes.slice(0, otpLength).forEach((box, index) => {
      box.value = digits[index];
      box.dispatchEvent(new InputEvent('input', { data: digits[index], bubbles: true }));
    });
  }, { capture: true });
}
